// https://marmelab.com/react-admin/CreateEdit.html#toolbar
// https://marmelab.com/react-admin/CreateEdit.html#the-simpleform-component
// https://marmelab.com/react-admin/Actions.html#the-simple-way

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { push as pushAction } from 'connected-react-router';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { required, showNotification as showNotificationAction, SimpleForm, TextInput } from 'react-admin';
import { AuthLayout, styles } from './authStyles';
import SaveButtonWithoutIcon from '../../components/SaveButtonWithoutIcon';
import { sendCustomApiRequest } from '../../dataProvider';

class RemindPassword extends Component {
  handleSubmit = (record) => {
    const { push, showNotification } = this.props;

    sendCustomApiRequest('/lost-password/send-email', { username: record.username })
      .then((res) => {
        if (res.status !== 200) {
          throw res.status;
        }
        showNotification('E-mail has been sent to the provided address.');
        push('/remindpassword/confirm');
      })
      .catch((e) => {
        showNotification(`Error: There was a server error, please try again (${e})`, 'warning');
      });
  };

  render() {
    return (
      <AuthLayout>
        <SimpleForm toolbar={<SimpleFormToolbar {...this.props} />} save={this.handleSubmit}>
          <Typography color="primary" variant="h6" gutterBottom>
            Password recovery
          </Typography>
          <Typography variant="body2">
            In case of losing access to our platform, please provide your e-mail address to reset your password
          </Typography>
          <TextInput fullWidth source="username" data-testid="forgot-password-username" label="E-mail" validate={required()} variant="standard"/>
        </SimpleForm>
      </AuthLayout>
    );
  };
};

const SimpleFormToolbar = ({ handleSubmitWithRedirect, classes, ...props }) => (
  <div className={classes.toolbar}>
    <SaveButtonWithoutIcon
      handleSubmitWithRedirect={handleSubmitWithRedirect}
      className="send-recovery-mail-button"
      data-testid="send-recovery-email"
      label="Send recovery email"
      submitOnEnter={true}
    />
    <Button component={Link} to="/login">
      Log in
    </Button>
  </div>
);

export default withStyles(styles)(connect(null, {
  showNotification: showNotificationAction,
  push: pushAction,
})(RemindPassword));
